import { initialValuesState as initialValues } from '../../../../../../../helpers/variablesInitialValues';
import * as types from '../types/stateType';

const initialState = {
	perPage: 10,
	page: 1,
	pages: 1,
	search: '',
	arrayList: [],
	arrayListToDropdown: [],
	refreshTable: false,
	isOpenModal: false,
	isOpenModalPermission: false,
	isLoadingShow: false,
	isLoadingForm: false,
	formType: '',
	formData: initialValues
};

const stateReducer = (state = initialState, { type, payload }) => {
	switch (type) {
		case types.PER_PAGE_STATE:
			return {
				...state,
				perPage: payload
			};
		
		case types.PAGE_STATE:
			return {
				...state,
				page: payload
			};
		
		case types.PAGES_STATE:
			return {
				...state,
				pages: payload
			};
		
		case types.SEARCH_STATE:
			return {
				...state,
				search: payload
			};
		
		case types.ARRAY_LIST_STATE:
			return {
				...state,
				arrayList: payload
			};
		
		case types.ARRAY_LIST_TO_DROPDOWN_STATE:
			return {
				...state,
				arrayListToDropdown: payload
			};
		
		case types.REFRESH_TABLE_STATE:
			return {
				...state,
				refreshTable: payload
			};
		
		case types.IS_OPEN_MODAL_STATE:
			return {
				...state,
				isOpenModal: payload
			};
		
		case types.IS_LOADING_SHOW_STATE:
			return {
				...state,
				isLoadingShow: payload
			};
		
		case types.IS_LOADING_FORM_STATE:
			return {
				...state,
				isLoadingForm: payload
			};
		
		case types.FORM_TYPE_STATE:
			return {
				...state,
				formType: payload
			};
		
		case types.FORM_DATA_STATE:
			return {
				...state,
				formData: payload
			};
		
		default:
			return state
	}
};

export default stateReducer;
